
import { Version } from './utils/versionUpdate';
import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from '@/App.vue'
import router from '@/router'
import pinia from '@/stores'
import 'virtual:uno.css'
import '@/styles/app.less'
import '@/styles/var.less'
import { i18n } from '@/utils/i18n'
import AppToast from './components/AppToast.vue'
import { getAssetsFile } from '@/utils/pub-use'
import authDialogPlugin from '@/plugins/auth-dialog'
import { initGentleAntiDebug } from '@/utils/gentle-anti-debug'
import { initMobileFriendlyAntiDebug } from '@/utils/mobile-friendly-anti-debug'
import { getAntiDebugConfig } from '@/config/anti-debug'
// 删除这行导入
// import { setGlobalRouter } from '@/utils/request'

console.log(Version.getVersion(), "version")
// import './utils/firebase';
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

// 扩展window类型
declare global {
  interface Window {
    $toast: (msg: string, duration?: number) => void
    $showLoginDialog: (inviteCode?: string) => void
    $showRegisterDialog: (inviteCode?: string) => void
    $hideAuthDialog: () => void
    $switchAuthMode: (isLogin: boolean) => void
    $setAuthInviteCode: (inviteCode: string) => void
    $adjustTracking: any
    $appsFlyerTracking: any
    __BUILD_TIMESTAMP__: string
  }
}

// Vant 桌面端适配
import '@vant/touch-emulator'

/* --------------------------------
Vant 中有个别组件是以函数的形式提供的，
包括 Toast，Dialog，Notify 和 ImagePreview 组件。
在使用函数组件时，unplugin-vue-components
无法自动引入对应的样式，因此需要手动引入样式。
------------------------------------- */
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

// 在创建 app 之后，设置全局 router
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(createHead())
app.use(authDialogPlugin)

// 删除这行
// setGlobalRouter(router)
app.config.globalProperties.getAssetsFile = getAssetsFile
const toastInstance = (app.mount('#app') as any).$refs.appToast

// 全局方法
window.$toast = (msg: string, duration = 2000) => {
  toastInstance.show(msg, duration)
}

// 添加全局属性


// 初始化反调试保护
const antiDebugConfig = getAntiDebugConfig();
if (antiDebugConfig.enabled) {
  if (antiDebugConfig.mode === 'mobile-friendly') {
    initMobileFriendlyAntiDebug();
  } else if (antiDebugConfig.mode === 'gentle') {
    initGentleAntiDebug();
  }
  console.log('🛡️ 反调试保护已启用，模式:', antiDebugConfig.mode);
} else {
  console.log('🛡️ 反调试保护已禁用');
}

// 挂载应用
// const mountedApp = app.mount('#app')


